import { Dispatch } from 'react';
import { Card, HTMLSelect } from '@blueprintjs/core';
import { ace } from '@axo/shared/data-access/types';
import cardClasses from '../CommunicationItem/Card.module.css';

interface Props {
  type: ace.OutboundNumberType;
  setType: Dispatch<ace.OutboundNumberType>;
}

export function CallOrderCard({ type, setType }: Props) {
  return (
    <Card className={cardClasses.card}>
      <div className={cardClasses.topBar}>
        <span>Choose caller:</span>
        <HTMLSelect
          value={type}
          onChange={(e) => setType(e.target.value as ace.OutboundNumberType)}
        >
          {options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </HTMLSelect>
      </div>
    </Card>
  );
}

const options: Array<{ label: string; value: ace.OutboundNumberType }> = [
  { label: 'Main number', value: 'broker' },
  { label: 'Agent number', value: 'agent' },
  { label: 'uScore', value: 'uscore' },
];
